import { FC, PropsWithChildren } from "react";
import { Router } from 'react-location'
import routes from "./routes";
import location from "./location";
import filterRoutes from "./filter";
import { useAuthStore } from "state/auth";

const RoutesProvider: FC<PropsWithChildren> = ({ children }) => {
  const currentUser = useAuthStore((state) => state.user);

  return (
    <div className={"light"}>
      <Router location={location} routes={routes} filterRoutes={filterRoutes(currentUser?.role?.permissions ?? [])}>
        {children}
      </Router>
    </div>
  )
}

export default RoutesProvider;
